import { IArtifactComponentProps } from "types/services";
import { IPhotoPropertyDetailsArtifact } from "types/artifacts/photo-property-details";
import { IPropertyId } from "types/artifacts/common";
import { PhotosSliderWithImagePreview } from "components/PhotosSliderWithImagePreview";
import { findArtifactByHarid } from "utils/helpers";
import { isProduction } from "scripts/application/setting";

export type IPhotoPropertyDetailsOutputProps = IArtifactComponentProps<
  IPropertyId,
  IPhotoPropertyDetailsArtifact
>;

PhotoPropertyDetailsOutput.artifactKey = "property_detail";

export function PhotoPropertyDetailsOutput(
  props: IPhotoPropertyDetailsOutputProps
): JSX.Element {
  const { harid, artifacts } = props;

  // if there is no valid artifacts return from the backend
  if (!Array.isArray(artifacts)) return <></>;

  if (!harid) {
    console.error("No harid provided for 'PhotoPropertyDetailsOutput'.");
    return <></>;
  }

  const artifact = findArtifactByHarid(artifacts, harid);
  const photos = artifact?.response?.photos?.items || [];

  if (!artifact || photos.length === 0) {
    console.error(
      "No artifact or photos found for 'PhotoPropertyDetailsOutput' with the given harid:",
      harid
    );
    return <></>;
  }

  return (
    <PhotosSliderWithImagePreview harid={harid} photos={photos} />
  );
}

PhotoPropertyDetailsOutput.asText = function (props: IPhotoPropertyDetailsOutputProps): string {
  // console.log("PhotoPropertyDetailsOutput.asText", props);
  return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.photos?.artifact_text || "" : isProduction ? "" : "PhotoPropertyDetailsOutput asText Not Implemented!";
}